import { NeedDto } from '@act/shared/data-transfer-objects';
import { Alert } from '@act/storybook';
import syvaNeedsUtils from 'react-components/needs/syva-needs-utils';
import { needRequests } from 'redux/requests/need.requests';
import { membersAppSelectors } from 'redux/slices/memberSlice';
import { useApiCall } from 'redux/utils/api-hook';

const NeedTimeAlert = ({
  need,
  showDaysRemaining = true,
}: {
  need: NeedDto;
  showDaysRemaining?: boolean;
}) => {
  const [_payload, _isLoading, patchNeed] = useApiCall(needRequests.patchNeed);
  const member = membersAppSelectors.useSelectMemberById(need.memberId);
  function extendTime() {
    patchNeed({
      body: { shouldExtend: true },
      params: { needId: need?.id },
    });
  }

  const daysRemaining = syvaNeedsUtils.calculateRemainingDays(need.expiresAt);
  const canExtendTime = daysRemaining < 7;
  const needEditable = syvaNeedsUtils.needIsEditable(need, member);

  if (!needEditable || !!need.fulfilledAt) {
    return null;
  }

  if (canExtendTime) {
    return (
      <Alert
        severity="warning"
        variant="tonal"
        trackingName="need-extend-time-alert"
        action={{
          label: 'Extend time',
          onClick: () => extendTime(),
          debounced: true,
        }}
      >
        {`Only ${daysRemaining} days remaining in time window`}
      </Alert>
    );
  } else {
    if (showDaysRemaining) {
      return (
        <Alert severity="info" variant="tonal" trackingName="need-time-remaining-alert">
          {`${daysRemaining} days remaining in time window`}
        </Alert>
      );
    }
  }
};

export default NeedTimeAlert;
